import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import Provider from '@orionx-dev/orionsoft-parts/lib/components/Provider/MeProvider/Provider'
import get from 'lodash/get'
import numeral from 'numeral'
import 'numeral/locales/es'
import numbro from 'numbro'
import cl from 'numbro/languages/es-CL'
import mx from 'numbro/languages/es-MX'

const GET_ME = gql`
  query getMe {
    me {
      _id
      roles
      emails {
        address
        verified
      }
      profile {
        countryCode
      }
    }
  }
`

const UserProvider = ({ children }) => {
  const { loading, data } = useQuery(GET_ME)
  const navigate = useNavigate()
  const [countryCode, setCountryCode] = useState('CL')

  useEffect(() => {
    const setLocales = () => {
      console.log('setrting locale')
      numeral.reset()
      if (countryCode === 'CL') {
        numeral.locale('es')
        numbro.culture('es', cl)
        numbro.culture('es')
      } else {
        numeral.reset()
        numbro.culture('es', mx)
        numbro.culture('es')
      }
    }
    setLocales()
  }, [countryCode])

  useEffect(() => {
    const newCountryCode = get(data, 'me.profile.countryCode')
    if (newCountryCode && newCountryCode !== countryCode) {
      console.log('setting new Country code', newCountryCode, countryCode)
      setCountryCode(newCountryCode)
    }
  }, [data, countryCode])

  if (loading || !data) {
    return children
  }

  const checkRoute = () => {
    const path = window.location.pathname
    if (path === '/login' && data?.me) {
      navigate('/accounts')
    }
  }

  checkRoute()
  return <Provider me={data?.me}>{children}</Provider>
}

UserProvider.propTypes = {
  children: PropTypes.node,
}

export default UserProvider
